import { AiDataRecognitionResult } from 'constants/documents';

export const BOUNDING_BOX_POP_UP_BOX_POSITION = {
  UPPER_LEFT: 'upper-left',
  UPPER_RIGHT: 'upper-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
};

const AiModelLayer = {
  LAYOUT: AiDataRecognitionResult.LAYOUT,
  AI_MODEL: AiDataRecognitionResult.AI_MODEL,
  MAPPED_AI_MODEL_FIELDS: AiDataRecognitionResult.MAPPED_AI_MODEL_FIELDS,
};

export const aiExtractionResultOptions = [
  {
    name: 'Layout',
    value: AiModelLayer.LAYOUT,
  },
];

export const PDF_PAGE_RENDER_WINDOW_RADIUS = 5;
